'use strict';

/**
 *
 * @name: followUs
 *
 */

import DirectiveTemplate from './nn-follow-us.directive.html';
import './nn-follow-us.directive.scss';

function FollowUsDirective(
  $location,
  $rootScope,
  $translate
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function(scope, element) {


      /*
      *
      * @CONFIG
      *
      */

      scope.item = scope.content();
      scope.loaded = true;
      scope.baiduTongji = icon => {
        window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
        if(icon){$rootScope.analytics.socialNetwork('Other module', icon)}
      }
      /*
      *
      * @PUBLIC
      *
      */


      /*
      *
      * @PRIVATE
      *
      */

      function _terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      function _mapData () {
        scope.item.jsonData.sources.forEach(function(item) {
          if (item.type === 'mailingList') {
            item.icon = 'mail';
          } else if (item.type === 'weechat') {
            item.icon = 'wechat';
          } else {
            item.icon = item.type;
          }
        });
      }

      /*
      *
      * @INIT
      *
      */

      if (!scope.item.jsonData.sources || !scope.item.jsonData.sources[0] || !scope.item.jsonData.sources[1]) {

        return _terminate();
      }

      if (!scope.item.title) {

        $rootScope.$on('$translateChangeSuccess', function() {

          scope.item.title = $translate.instant('MORE_FROM_NOWNESS');
        });
      }

      _mapData()

      setTimeout(function() {
        if (element && element.equalizeHeight) {
          element.equalizeHeight('.post__desc');
        }
      });

    }
  };
}

export default FollowUsDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-follow-us/nn-follow-us.directive.js